import { useEffect, useState } from 'react';
export const useDropdownState = disabled => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  // Close already open dropdown when it becomes disabled
  useEffect(() => {
    if (disabled) {
      setIsOpen(false);
    }
  }, [disabled]);
  return {
    state: {
      isOpen,
      activeIndex
    },
    handleOpenChange: setIsOpen,
    handleActiveIndexChange: setActiveIndex
  };
};